export default __webpack_public_path__ + "static/media/logo-link-blanco.b920d7eb.png";